import AuthSideNav from "components/AuthNav/SideBar"
import { observer } from "mobx-react-lite"
import React, { useContext, useEffect } from "react"
import { DashboardLayout } from "./style"
import { AuthContext } from "context/AuthContext"
import { useNavigate } from "react-router-dom"
import { LOGIN_ROUTE } from "routes"
import FullScreenLoader from "components/Dashboard/FullScreenLoader"

const Mainlayout = props => {
	const {adminProfile,isLoading} = useContext(AuthContext)

	const navigate = useNavigate()

	useEffect(()=>{
		if(!isLoading && !adminProfile){
			navigate(LOGIN_ROUTE)
		}
	},[isLoading,adminProfile,navigate])

	if(isLoading){
		return (
			<FullScreenLoader/>
		)
	}

	return (
		<div className="bg-[#E7E7ED]">
			<DashboardLayout>
				<AuthSideNav user={adminProfile} />
				<div className=" ml-[250px] py-[35px] px-[42px]">
					{adminProfile && props.children}
				</div>
			</DashboardLayout>
		</div>
	)
}

export default observer(Mainlayout)
